import React, { Component } from "react";
import { connect } from "react-redux";
import Downshift from "downshift";
import styled from "styled-components";
import Input from "components/Common/Forms/Input";
import { selectAccountProfileAttributeByName } from "reducers/account/profileAttributes";

export class AutosuggestProfileAttributes extends Component {
  /**
   * Given an input value and an array of string suggestions, return
   * the potential matches found.
   *
   * @param inputValue
   * @param suggestions
   * @returns {*}
   */

  getMatchingSuggestions = (inputValue, suggestions) => {
    return suggestions.filter(
      suggestion =>
        suggestion &&
        (!inputValue ||
          (suggestion.toLowerCase &&
            suggestion.toLowerCase().includes(inputValue.toLowerCase())))
    );
  };

  render() {
    const {
      value,
      profileAttribute,
      onChange,
      onKeyDown,
      className
    } = this.props;

    const propertySuggestions =
      (profileAttribute && profileAttribute.values) || [];
    const placeholder =
      propertySuggestions && propertySuggestions.length > 0
        ? `e.g. ${propertySuggestions[0]}`
        : "";

    const keyDownHandler = onKeyDown ? onKeyDown : () => {};

    return (
      <div className={className}>
        <Downshift
          selectedItem={value}
          onInputValueChange={onChange}
          className={className}
        >
          {({
            getInputProps,
            getItemProps,
            isOpen,
            inputValue,
            highlightedIndex,
            closeMenu
          }) => (
            <div data-testid="inner-wrapper">
              <Input
                data-testid="inner-wrapper-input"
                {...getInputProps({
                  onKeyDown: event => {
                    keyDownHandler(event, highlightedIndex, closeMenu);
                  },
                  placeholder
                })}
              />
              {isOpen ? (
                <Suggestions data-testid="inner-suggestions-menu">
                  {this.getMatchingSuggestions(
                    inputValue,
                    propertySuggestions
                  ).map((item, index) => (
                    <Suggestion
                      {...getItemProps({ item })}
                      key={item}
                      active={highlightedIndex === index}
                      className="suggestion"
                    >
                      {item}
                    </Suggestion>
                  ))}
                </Suggestions>
              ) : null}
            </div>
          )}
        </Downshift>
      </div>
    );
  }
}

// language=SCSS prefix=dummy{ suffix=}
const Suggestions = styled.div`
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  border: 2px solid ${props => props.theme["$gray-3"]};
  border-top: none;
  border-radius: 0 0 4px 4px;
  z-index: 2147483647;
  background-color: white;
`;

// language=SCSS prefix=dummy{ suffix=}
const Suggestion = styled.div`
  padding: 6px;
  font-size: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: ${props => props.active && props.theme["$purple-light"]};
  &:hover {
    cursor: pointer;
  }
`;

function mapStateToProps(state, ownProps) {
  return {
    profileAttribute: selectAccountProfileAttributeByName(
      state,
      ownProps.property
    )
  };
}

export default connect(mapStateToProps)(
  // language=SCSS prefix=dummy{ suffix=}
  styled(AutosuggestProfileAttributes)`
    position: relative;
    flex-grow: 1;
    input {
      width: 100%;
    }
  `
);
